import React from "react";
import { SidebarItemProps } from "../type";
import "../styles/sidebaritem.scss";

const SidebarItem = ({ item, onClick, isSelected }: SidebarItemProps) => {
  const classSelected = isSelected ? "item-selected" : "";
  return (
    <div
      className={`side-bar-site-item normal-button ${classSelected}`}
      onClick={onClick}
    >
      <span>{item.name}</span>
      <span className="total">{item.total}</span>
    </div>
  );
};

export default SidebarItem;
